import { translate } from '../i18n/index.js';
import { ERROR_CODES } from './codes.js';
export * from './codes.js';
export * from './details.js';
/** Builds a failure. The overload-free form: pass what you have, omit what you do not. */
export function failure(code, extra = {}) {
    return {
        code,
        ...(extra.params === undefined ? {} : { params: extra.params }),
        ...(extra.details === undefined ? {} : { details: extra.details }),
    };
}
/** The HTTP status a failure is returned with, which the code alone decides. */
export function statusOf(value) {
    return ERROR_CODES[value.code].status;
}
/** Renders a failure into the wire contract, in one language. */
export function toErrorBody(value, locale) {
    const message = translate(locale, ERROR_CODES[value.code].messageKey, value.params);
    return {
        error: {
            code: value.code,
            message,
            ...(value.details === undefined ? {} : { details: value.details }),
        },
    };
}
/**
 * Recognises the contract in an arbitrary parsed response.
 *
 * Used by the browser client, which must tell a contract-shaped failure from a proxy's HTML error
 * page: the second one is what a caller gets when the stack is half up, and treating it as the
 * first produces `undefined` in a message box instead of a readable failure.
 */
export function isApiErrorBody(value) {
    if (typeof value !== 'object' || value === null || !('error' in value)) {
        return false;
    }
    const { error } = value;
    if (typeof error !== 'object' || error === null) {
        return false;
    }
    const candidate = error;
    return (typeof candidate.code === 'string' &&
        typeof candidate.message === 'string' &&
        Object.hasOwn(ERROR_CODES, candidate.code));
}
//# sourceMappingURL=index.js.map